import React from 'react';

import { useField } from 'formik';


const TextMulti = ({ label, required,...props }) => {
	// useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
	// which we can spread on <input> and also replace ErrorMessage entirely.
	const [field, meta] = useField(props);
	let clsName = 'form-control ';

	clsName = meta.touched && meta.error ? clsName + ' missing ' : clsName;
	clsName = required ? clsName + 'required' : clsName;
	let reqLabel = required ? ' *' : '';

	return (
		<>
		<label htmlFor={props.id || props.name}>{label}{reqLabel}</label>
		<textarea className={clsName} {...field} {...props} />
		</>
	);
};
export default TextMulti;